import React, { ReactElement } from 'react';
import { useAppDispatch } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Grid, TextField, MenuItem } from '@mui/material';

import { PayloadData, WalletType, saveSelectedWalletIds } from 'redux/wallet/walletSlice';

import styles from "./styles.module.scss";
interface IProps {
  data: PayloadData;
  walletTypeOptions: WalletType[];
  action: string;
  handleChange: (name: string, value: string, group: string) => void;
}

export default function WalletInformation({
  data,
  walletTypeOptions,
  action,
  handleChange
}: IProps): ReactElement {
  const dispatch = useAppDispatch();
  return (
    <Grid container spacing={1} direction="row" >
      <Grid item xs={12} md={6} >
        <TextField
          select
          name="wallet_type_id"
          value={walletTypeOptions.length ? data?.wallet.wallet_type_id : walletTypeOptions[0]?.id || ""}
          id="Wallet Type"
          label={<Translate value="walletInformation.wallet_type_id" />}
          size="small"
          fullWidth
          color="secondary"
          required
          disabled={action === "edit" ? true : false}
          onChange={(event) => {
            handleChange(event.target.name, event.target.value, 'wallet')
            typeof event.target.value !== "string"
              && dispatch(
                saveSelectedWalletIds({
                  walletTypeId: event.target.value
                }))
          }}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#969393",
            },
          }}
          className={[styles.label, "form-label"].join(" ")}

        >
          {
            walletTypeOptions.map((option) => {
              return (
                <MenuItem key={option.label} value={option.id} className={styles.label}>
                  {option.label}
                </MenuItem>
              )
            })
          }
        </TextField>
      </Grid>
    </Grid >
  );
}